import { render, staticRenderFns } from "./ExportSection.vue?vue&type=template&id=70c2cda8&scoped=true"
import script from "./ExportSection.vue?vue&type=script&lang=js"
export * from "./ExportSection.vue?vue&type=script&lang=js"
import style0 from "./ExportSection.vue?vue&type=style&index=0&id=70c2cda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2cda8",
  null
  
)

export default component.exports